module.exports = __webpack_public_path__ + "static/media/cross-button.2cc7af6e.svg";